module.exports = __webpack_public_path__ + "img/蛇六谷.7069a6dc.jpg";